import { createEmptyFetchable } from 'helpers/loadableHelpers'
import { Reducer } from 'interfaces'
import { CreditCardAppState } from 'components/features/creditCard/creditCardStore/state'
import { PatchCCOnboardingPropsAction } from 'components/features/creditCard/creditCardStore/actions'

const INITIAL_STATE = createEmptyFetchable<CreditCardAppState['patchOnboardingPropsRequest']['data']>()
export const patchOnboardingPropsRequestReducer: Reducer<CreditCardAppState['patchOnboardingPropsRequest']> = (prevState = INITIAL_STATE, action) => {
  switch (action.type) {
    case PatchCCOnboardingPropsAction.type: {
      if (action.meta === 'request') {
        if (action.payload.params.person_data === undefined) {
          return prevState
        }

        return {
          ...INITIAL_STATE,
          isLoading: true,
          data: action.payload.params.person_data,
        }
      }

      if (action.meta === 'fail') {
        return {
          ...prevState,
          isLoading: false,
          errorCode: action.payload.errorCode,
          errorsMap: action.payload.errorsMap,
        }
      }


      return {
        ...INITIAL_STATE,
        data: action.payload.response.person_data,
      }

    }
  }
  return prevState

}
